import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

// #root ships with a static SEO fallback (real H1/H2 + links) so the raw HTML
// source always contains crawlable content — even before/without JS, and in the
// dev server. createRoot cleanly replaces that fallback with the live app on mount.
// (react-snap still bakes full per-route content into the production HTML.)
ReactDOM.createRoot(rootElement).render(tree);
